export default __webpack_public_path__ + "static/media/stf-12.bc5ed789.svg";